import {
  Popover as ShadcnPopover,
  PopoverTrigger,
  PopoverContent,
} from '@workspace/ui/components/popover';
import { type ReactNode, useState } from 'react';

interface PopoverProps {
  element: ReactNode;
  content: ReactNode;
  contentOptions?: {
    side: 'top' | 'bottom' | 'left' | 'right';
    align?: 'start' | 'center' | 'end';
  };
  disabled?: boolean;
}

export function Popover({ element, content, contentOptions, disabled }: PopoverProps) {
  const [open, setOpen] = useState(false);

  return (
    <ShadcnPopover
      open={open}
      onOpenChange={(open) => {
        if (disabled) return;
        setOpen(open);
      }}
    >
      <PopoverTrigger asChild disabled={disabled}>
        {element}
      </PopoverTrigger>
      <PopoverContent
        side='bottom'
        sideOffset={8}
        align='end'
        onClick={(e) => {
          e.stopPropagation();
          setOpen(false);
        }}
        className='flex flex-col gap-2 w-fit rounded-2xl border-none p-2 shadow-[0px_0px_24px_0px_rgba(0,0,0,0.12)]'
        {...contentOptions}
      >
        {content}
      </PopoverContent>
    </ShadcnPopover>
  );
}

export * from './popover-list';
